import { OnDestroy, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'matchBold',
  standalone: false
})
export class MatchBoldPipe implements PipeTransform, OnDestroy {

  ngOnDestroy() {
  }

  transform(value: string, searchTerm: string): string {
    if (!searchTerm) {
      return value;
    }

    const formattedSearchTerm = searchTerm.replace(/[<>*()?]/g, '\\$&');
    const regex = new RegExp(formattedSearchTerm, 'gi');
    return value.replace(regex, (match) => `<strong>${match}</strong>`);
  }
}
